import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as userInfoActions } from '../../appstate/userInfo';
import { formatOrders } from '../utils';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset() {
    return actions.reset();
}

function fetch(locale) {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let meta;
        let error;
        try {
            const allOrders = await AccountService.getTrips(locale);
            const orders = formatOrders(allOrders);

            return dispatch(userInfoActions.setUserOrders(orders));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTrips', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

export {
    fetch,
    reset,
};
